import React from 'react'
import DispatchView from '../../components/dispatch/dispatchview'

export default function Dispatch() {
  return (
    <>
    <div className='px-4'>
        <DispatchView/>
    </div>
    </>
  )
}
